import { FC, PropsWithChildren } from 'react'
import styled from 'styled-components'
import { Navigate, Outlet } from 'react-router-dom'
import { useAuthContext } from '../../../state/useAuth'
import { ROUTES } from '../../../constants/routes'
import Spinner from '../../shared/Spinner'

const LoaderStyled = styled.div`
  min-height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
`

const RoleGuard: FC<PropsWithChildren> = ({ children }) => {
  const { authData, isAuthInitialized } = useAuthContext()

  if (!isAuthInitialized) {
    return (
      <LoaderStyled>
        <Spinner widthHeight={42} />
      </LoaderStyled>
    )
  }

  if (authData?.userRole !== 'admin') {
    return <Navigate to={ROUTES.DATASETS} replace />
  }

  return (
    children
      ? <>{children}</>
      : <Outlet />
  )
}

export default RoleGuard
